import(/* webpackMode: "eager", webpackExports: ["StudySlugPageLayout"] */ "/home/runner/work/pandahub-website-nextjs/pandahub-website-nextjs/components/blog/studies-slug-page-layout.tsx");
